import { gql } from "@apollo/client";

export const UPDATE_USER_AND_COMPANY_INFO = gql`
    mutation updateUserAndCompanyInfo($id: ID!, $name: String, $title: String, $companyName: String!, $bundesland: String) {
        updateUser(id: $id, name: $name, title: $title) {
            id
            name
            title
        }

        updateCompany(name: $companyName, locations: [$bundesland]) {
            id
            name
            createdAt
            updatedAt
            ownerId
            details {
                id
                description
                employeeCount
                metadata
            }
        }
    }
`;
